import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper/modules'
Swiper.use([Pagination, Navigation, Autoplay]);

const industriesSwiper = new Swiper('.industries-swiper',{
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  navigation:{
    prevEl: '.industries-swiper-prev',
    nextEl: '.industries-swiper-next',
  },
  breakpoints:{
    600:{
      slidesPerView: 2,
    },
    900:{
      slidesPerView: 3,
    },
    1201:{
      slidesPerView: 1.8,
    },
    1450:{
      slidesPerView: 2.8,
    },
  }
});
